import React from 'react';
import AttendanceCalendar from './AttendanceCalendar';

const Attendance = () => {
  return <AttendanceCalendar />;
};

export default Attendance;
